import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from '../operator_home/sidebar/Sidebar'
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import upload from "../../assets/upload.svg";
import fileUp from "../../assets/fileUp.svg";
import { ReactSession } from "react-client-session";

import "./UploadReconcilation.css";
import { getErrorToast, getSuccessToast, getWarningToast } from "../../toast";

function UploadReconcilation() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isupload, setisupload] = useState(false);
  const [fileName, setfileName] = useState("");
  const [file, setfile] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  
  const box_id = ReactSession.get("box_id");
  const role = ReactSession.get("role");


  useEffect(() => {
    setLoading(true);
    axiosPrivate
      .get(`reconcilation/reconciliation-pdfs/${box_id}/`)
      .then((response) => {
        setMessage(response.data.error_message)
      })
      .catch((err) => {
        console.log('Can not load lase file error');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const fileChangeHandler = (event) => {
    event.preventDefault();
    if (event.target.value === "") {
      return;
    }

    const file = event.target.files[0];
    
    // Check if a file is selected
    if (file) {
        // Get the MIME type of the file
        const fileType = file.type;
        
        // Check if the MIME type is allowed
        if (fileType === 'application/pdf' || 
            fileType === 'application/vnd.ms-excel' ||
            fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            fileType === 'text/csv'||
            fileType === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
            // File type is allowed, you can proceed with uploading or further processing
            console.log('File type is allowed:', fileType);
            setfile(file);
            setfileName(file.name);
            setisupload(true);
        } else {
            // File type is not allowed, inform the user
            getErrorToast('Only PDF, Excel (XLS/XLSX), and CSV files are allowed.');
            // Clear the file input
            event.target.value = '';
        }
    }
  };

  const formdata = new FormData();
  formdata.append("file", file);
  formdata.append("gpt", true);

  const submitHandler = (event) => {
    event.preventDefault();

    setLoading(true);
    axiosPrivate
      .post(`reconcilation/reconcilation/${box_id}`, formdata)
      .then((res) => {
        if (res.status === 200){
          if(role === "3"){
            navigate("/scan")
            return
          }
          navigate("/")
          getSuccessToast("File Processing in background.")
        }
      })
      .catch((err) => {
        getWarningToast('Please try a different document or check if the PDF is readable and of good quality.')
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="main-upContainer">
        <Header />
        {role === '2' ? <Sidebar className="sidebar-operator-home" /> : <OtherSidebar className="sidebar-operator-home"/>}
        <div className="upload-outer-sec">
          <div className="upload-cont-head">
            <h3>Claim Upload</h3>
          </div>
          <div className="upload-box-container">
            <span className="register-form-user-exists-message">{message && message}</span>
            <div className="upload-box-skip-btn-container">
              {role==='3' ? <button onClick={() => navigate("/scan")} className="skip-btn">
                Skip & Scan Medicine
              </button>:
              <button onClick={() => navigate("/")} className="skip-btn">
              Skip
            </button>
              }
            </div>
            <div className="uploadBox">
              <div className="cont-head" id="clrep-head">
                {!isupload && <h3>Upload Claim Report</h3>}
              </div>

              <div className="upl-img">
                <img id="upload" src={isupload ? fileUp : upload} alt="" />
              </div>
              {isupload && <div className="fileName">{fileName}</div>}
              <div className="upl-btn">
                <label
                  htmlFor="upload-rc"
                  id="browseF"
                  style={{ textAlign: "center" }}
                >
                  {isupload ? "Change file" : "Browse file"}
                </label>
                <input
                  type="file"
                  onChange={fileChangeHandler}
                  id="upload-rc"
                  hidden
                  accept=".xlsx, .xlsb, .xls, .pdf, .csv"
                />
              </div>
            </div>
          </div>
          <div className="submitRC">
            {isupload &&
              <button
                onClick={submitHandler}
                id="subRc-btn"
              >
                Upload File
              </button>
            }
          </div>
        </div>
      </div>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress color="inherit" />
            <p style={{ textAlign: "center", paddingTop: "1rem" }}>
              Reading claim file...
            </p>
          </div>
        </Backdrop>
      )}
    </div>
  );
}

export default UploadReconcilation;
